import {
  useNavigate,
  useTranslation,
  useLocation,
  Dropdown,
} from "../vendor/api.js"; // Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 4655, offsets 231339:239898. Structure and names inferred from code, not screenshots.
import dependency66380 from "../routing/searchIndexContext.js";
import * as jsxRuntime from "react/jsx-runtime";
import * as React from "react";
import { module87548 as l } from "../vendor/dependencies.js";
import { module37552 as c } from "../vendor/dependencies.js";
import * as DocumentNavigationModule from "../routing/documentNavigation.js";
import * as LocaleContext from "../i18n/I18nProvider.jsx";
import * as LocalizedPathsModule from "../routing/localizedPaths.js";
import * as FormatValueModule from "../utils/formatValue.js";
let u = {};
async function p(e = "zh") {
  if (u[e]) return u[e];
  try {
    let t = await dependency66380(`./doc-search-index.${e}.json`),
      n = t.default || t;
    return ((u[e] = n), n);
  } catch (t) {
    return (
      console.error(`加载${"zh" === e ? "中文" : "英文"}搜索索引失败:`, t),
      []
    );
  }
}
function m(e, t, i = 150) {
  let n = e.toLowerCase(),
    o = t.toLowerCase(),
    a = n.indexOf(o);
  if (-1 === a) return e.slice(0, Math.max(0, i));
  let r = Math.max(0, a - 50),
    l = Math.min(e.length, a + t.length + 50),
    s = e.slice(r, l);
  return (r > 0 && (s = `...${s}`), l < e.length && (s += "..."), s);
}
function M() {
  return (
    <svg
      width={"10"}
      height={"10"}
      viewBox={"0 0 10 10"}
      fill={"none"}
      xmlns={"http://www.w3.org/2000/svg"}
    >
      <path
        d={
          "M8.20581 1.90892C8.4117 1.69634 8.40668 1.35821 8.1941 1.15232C7.98151 0.946435 7.64338 0.951457 7.4375 1.16404L4.83961 3.84227L4.07129 4.63235V1.53565C4.07129 1.23937 3.83193 1 3.53565 1C3.23937 1 3 1.23937 3 1.53565V7.9634C3 8.25968 3.23937 8.49905 3.53565 8.49905C3.83193 8.49905 4.07129 8.25968 4.07129 7.9634V6.17234L5.1543 5.05585L7.38058 8.26973C7.54965 8.51244 7.88275 8.5727 8.12547 8.40531C8.36818 8.23792 8.42844 7.90314 8.26105 7.66043L5.91425 4.27079L8.20581 1.90892Z"
        }
        fill={"#646A73"}
      />
    </svg>
  );
}
var y = "search-dropdown_desktopDropdownContent__Reoe-",
  x = "search-dropdown_mobileDropdownContent__Reoe-";
function DocSearch({
  className: className,
  isMobile: t = false,
  onNavigate: onNavigate,
  getPopupContainer: getPopupContainer,
}) {
  let b = useNavigate(),
    { t: translate } = useTranslation(),
    { language: language } = (0, LocaleContext.useI18n)(),
    C = useLocation(),
    [w, A] = (0, React.useState)(""),
    [D, j] = (0, React.useState)([]),
    [v, I] = (0, React.useState)(true),
    [P, S] = (0, React.useState)([]),
    [z, L] = (0, React.useState)(false),
    [E, O] = (0, React.useState)(false),
    U = (0, React.useRef)(null),
    [_, V] = (0, React.useState)(false);
  (0, React.useEffect)(() => {
    V(
      !("u" < typeof window) &&
        (/mac|iphone|ipod|ipad/i.test(navigator.platform) ||
          /mac/i.test(navigator.userAgent)),
    );
  }, []);
  let F = (0, React.useMemo)(() => w.trim().length > 0 || z, [w, z]),
    Y = (0, React.useMemo)(() => w.trim().length > 0, [w]);
  ((0, React.useEffect)(() => {
    (I(true),
      p(language)
        .then((e) => {
          (j(e), I(false));
        })
        .catch((e) => {
          (console.error("加载搜索索引失败:", e), I(false));
        }));
  }, [language]),
    (0, React.useEffect)(() => {
      if (!w.trim() || v || 0 === D.length) {
        (S([]), O(false));
        return;
      }
      (S(
        (function (e, t, i) {
          if (!e.trim()) return [];
          let n = e.toLowerCase().trim(),
            o = [];
          for (let a of i) {
            if (a.language !== t) continue;
            let i = [];
            for (let t of a.blocks || []) {
              let o = t.h2Title?.toLowerCase().includes(n) || false,
                a = t.cleanContent?.toLowerCase().includes(n) || false;
              if (o || a) {
                let n = a ? m(t.content, e) : t.content.slice(0, 150);
                i.push({
                  ...t,
                  matchedText: n,
                });
              }
            }
            let r =
                a._searchMeta?.cleanContent?.toLowerCase().includes(n) || false,
              l = a.content?.toLowerCase().includes(n) || false,
              s = a.title.toLowerCase().includes(n),
              c = a.h1Title?.toLowerCase().includes(n) || false;
            if ((r || l) && 0 === i.length) {
              for (let t of a.blocks || [])
                t.content?.toLowerCase().includes(n) &&
                  i.push({
                    ...t,
                    matchedText: m(t.content, e),
                  });
              0 === i.length &&
                i.push({
                  h2Title: a.h1Title || a.title,
                  content: a.content,
                  cleanContent: a._searchMeta?.cleanContent || a.content,
                  matchedText: m(a.content, e),
                });
            }
            (s || c || i.length > 0) &&
              o.push({
                href: a.href,
                title: a.title,
                h1Title: a.h1Title || a.title,
                matchedBlocks: i,
              });
          }
          let a = new Map(
            (function e(t, i = "") {
              let n = [];
              for (let o of t)
                if ("href" in o && "key" in o) {
                  let t = i + o.href;
                  (o.noLink || n.push(t), o.items && n.push(...e(o.items, t)));
                }
              return n;
            })(DocumentNavigationModule.jj).map((e, t) => [e, t]),
          );
          return (
            o.sort((e, t) => {
              if (e.matchedBlocks.length !== t.matchedBlocks.length)
                return t.matchedBlocks.length - e.matchedBlocks.length;
              let i = +!!e.title.toLowerCase().includes(n),
                o = +!!t.title.toLowerCase().includes(n);
              return i !== o
                ? o - i
                : (a.get(e.href) ?? 1 / 0) - (a.get(t.href) ?? 1 / 0);
            }),
            o
          );
        })(w, language, D),
      ),
        O(true));
    }, [w, language, D, v]),
    (0, React.useEffect)(() => {
      let e = (e) => {
        if ((_ ? e.metaKey : e.ctrlKey) && ("k" === e.key || "K" === e.key)) {
          (e.preventDefault(),
            e.stopPropagation(),
            e.stopImmediatePropagation());
          let t = U.current?.input || U.current;
          t &&
            setTimeout(() => {
              t.focus();
            }, 0);
        }
      };
      return (
        window.addEventListener("keydown", e, true),
        () => {
          window.removeEventListener("keydown", e, true);
        }
      );
    }, [_]),
    (0, React.useEffect)(() => {
      let e = (e) => {
        if ("Escape" === e.key || "Esc" === e.key) {
          let t = U.current?.input || U.current,
            i = document.activeElement === t;
          (w.trim() || i) &&
            (e.preventDefault(),
            e.stopPropagation(),
            A(""),
            S([]),
            O(false),
            i && t && t.blur());
        }
      };
      return (
        window.addEventListener("keydown", e),
        () => {
          window.removeEventListener("keydown", e);
        }
      );
    }, [w]));
  let R = (0, React.useCallback)(
      (e) => {
        (e || !(w.trim().length > 0)) && O(e);
      },
      [w],
    ),
    B = (0, React.useCallback)(
      (e, t) => {
        let n = e.href.startsWith("/docs")
            ? e.href
            : `/docs${e.href.startsWith("/") ? "" : "/"}${e.href}`,
          o = (0, LocalizedPathsModule.BC)(n, C.pathname, language);
        if (
          (b(`${o}?target=${(0, FormatValueModule.z)(t.h2Title)}`),
          o === C.pathname)
        ) {
          let e = document.querySelector(
              `[id="${(0, FormatValueModule.z)(t.h2Title)}"]`,
            ),
            i = document.querySelector("main");
          if (e && i) {
            let t = window.innerWidth >= 1024 ? 64 : 52,
              n =
                Number.parseInt(
                  window.getComputedStyle(e).scrollMarginTop,
                  10,
                ) || 0,
              o = i.getBoundingClientRect(),
              a = e.getBoundingClientRect(),
              { scrollTop: scrollTop } = i,
              l = a.top - o.top + scrollTop - (t + n);
            i.scrollTo({
              top: Math.max(0, l),
              behavior: "smooth",
            });
          }
        }
        (A(""), S([]), O(false), onNavigate?.());
      },
      [b, C.pathname, onNavigate, language],
    ),
    Q = (0, React.useMemo)(
      () =>
        Y ? (
          0 === P.length ? (
            <div className={t ? x : y}>
              <div className={"search-dropdown_noResults__Reoe-"}>
                {translate("common.noResults")}
              </div>
            </div>
          ) : (
            <div className={t ? x : y}>
              {P.map((e) =>
                0 === e.matchedBlocks.length ? null : (
                  <div
                    key={e.href}
                    className={"search-dropdown_resultGroup__Reoe-"}
                  >
                    <div className={"search-dropdown_groupTitle__Reoe-"}>
                      {e.h1Title}
                    </div>
                    {e.matchedBlocks.map((t) => (
                      <div
                        key={`${e.href}-${(0, FormatValueModule.z)(t.h2Title)}`}
                        className={"search-dropdown_resultItem__Reoe-"}
                        onClick={() => B(e, t)}
                      >
                        <div className={"search-dropdown_resultTitle__Reoe-"}>
                          {t.h2Title}
                        </div>
                        <div className={"search-dropdown_resultContent__Reoe-"}>
                          {(function (e, t) {
                            if (!t.trim()) return e;
                            let i = t.replaceAll(/[$()*+.?[\\\]^{|}]/g, "\\$&"),
                              o = RegExp(`(${i})`, "gi");
                            return e.split(o).map((e, t) =>
                              RegExp(`^${i}$`, "i").test(e) ? (
                                <span
                                  key={t}
                                  style={{
                                    color: "#FB8147",
                                  }}
                                >
                                  {e}
                                </span>
                              ) : (
                                <span key={t}>{e}</span>
                              ),
                            );
                          })(t.matchedText, w)}
                        </div>
                      </div>
                    ))}
                  </div>
                ),
              )}
            </div>
          )
        ) : null,
      [P, w, Y, t, B, translate],
    ),
    q = (0, React.useMemo)(
      () => (
        <div className={"flex-1"}>
          <l.A
            ref={U}
            value={w}
            onChange={(e) => A(e.target.value)}
            onFocus={() => {
              (L(true), Y && O(true));
            }}
            onBlur={() => L(false)}
            placeholder={translate("common.searchDocs")}
            bordered={false}
            className={"flex-1 bg-transparent border-0"}
            style={{
              paddingLeft: "8px",
              fontSize: "13px",
              color: w ? "#1f2329" : "#8f959e",
              backgroundColor: "transparent",
              padding: 0,
              boxShadow: "none",
            }}
            styles={{
              input: {
                backgroundColor: "transparent",
                outline: "none",
                padding: 0,
                fontSize: "13px",
                lineHeight: "32px",
                color: w ? "#1f2329" : "#8f959e",
                boxShadow: "none",
              },
            }}
          />
        </div>
      ),
      [w, Y, translate],
    );
  return (
    <div
      className={`flex flex-col gap-[10px] w-full relative ${className || ""}`}
    >
      <div
        className={
          "search-dropdown_searchInputWrapper__Reoe- bg-black/5 flex gap-[4px] items-center pr-[12px] rounded-[6px] w-full relative"
        }
      >
        <Dropdown
          open={E}
          onOpenChange={R}
          dropdownRender={() => Q || <div />}
          trigger={["click"]}
          placement={t ? "bottom" : "bottomLeft"}
          overlayClassName={
            t
              ? "search-dropdown_mobileSearchDropdown__Reoe-"
              : "search-dropdown_desktopSearchDropdown__Reoe-"
          }
          getPopupContainer={getPopupContainer || (() => document.body)}
        >
          {q}
        </Dropdown>
        {t ? (
          w.trim().length > 0 ? (
            <div
              onClick={() => {
                (A(""), S([]), O(false));
              }}
              className={
                "flex items-center justify-center text-[#646a73] cursor-pointer"
              }
              style={{
                fontSize: "10px",
                lineHeight: "10px",
                fontWeight: 500,
              }}
            >
              <svg
                width={"14"}
                height={"14"}
                viewBox={"0 0 14 14"}
                fill={"none"}
                xmlns={"http://www.w3.org/2000/svg"}
              >
                <path
                  fillRule={"evenodd"}
                  clipRule={"evenodd"}
                  d={
                    "M1.16675 7.0013C1.16675 3.77964 3.77842 1.16797 7.00008 1.16797C10.2217 1.16797 12.8334 3.77964 12.8334 7.0013C12.8334 10.223 10.2217 12.8346 7.00008 12.8346C3.77842 12.8346 1.16675 10.223 1.16675 7.0013ZM4.73335 5.55961L6.17703 7.00329L4.73335 8.44697L5.55831 9.27192L7.00199 7.82825L8.44566 9.27192L9.27062 8.44697L7.82695 7.00329L9.27062 5.55961L8.44566 4.73465L7.00199 6.17833L5.55831 4.73465L4.73335 5.55961Z"
                  }
                  fill={"#646A73"}
                />
              </svg>
            </div>
          ) : null
        ) : (
          <div
            className={
              "bg-white flex gap-[2px] items-center p-[4px] rounded-[4px] shrink-0"
            }
          >
            {F ? (
              <div
                className={"flex items-center justify-center text-[#646a73]"}
                style={{
                  fontSize: "10px",
                  lineHeight: "10px",
                  fontWeight: 500,
                }}
              >
                {"Esc"}
              </div>
            ) : (
              <jsxRuntime.Fragment>
                {_ ? (
                  <div
                    className={
                      "flex items-center justify-center overflow-clip w-[10px] h-[10px]"
                    }
                  >
                    <c.A className={"w-[10px] h-[10px] text-[#646a73]"} />
                  </div>
                ) : (
                  <div
                    className={
                      "flex items-center justify-center text-[#646a73]"
                    }
                    style={{
                      fontSize: "10px",
                      lineHeight: "10px",
                      fontWeight: 500,
                    }}
                  >
                    {"Ctrl"}
                  </div>
                )}
                <div
                  className={
                    "flex items-center justify-center overflow-clip w-[10px] h-[10px]"
                  }
                >
                  <M />
                </div>
              </jsxRuntime.Fragment>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
export { DocSearch };
